import orderImage from "@/assets/transfer/order_number.png";
import logisticsImage from "@/assets/transfer/logistics_number.png";
import {
  NumberBoxInner,
  NumberBoxInnerTitle,
  NumberBoxInnerText,
  NumberBoxInnerImage,
} from "./styles";
import { Text } from "@/pages/transfer/components/styles";

const Images: Record<string, string> = {
  order: orderImage,
  logistics: logisticsImage,
};

type NumberTextProps = {
  type: "order" | "logistics";
  title: string;
  info?: string;
};

const NumberText = (props: NumberTextProps) => {
  const { type = "order", title, info } = props;
  if (!info) {
    return;
  }
  return (
    <NumberBoxInner>
      <NumberBoxInnerTitle>
        <NumberBoxInnerImage src={Images[type]}></NumberBoxInnerImage>

        <span style={{ marginLeft: 8, lineHeight: "18px" }}>{title}：</span>
      </NumberBoxInnerTitle>
      <NumberBoxInnerText>
        <Text
          $wordBreak="break-all"
          $color="#45629d"
          $fontSize="12px"
          $lineHeight="18px"
        >
          {info}
        </Text>
      </NumberBoxInnerText>
    </NumberBoxInner>
  );
};
export default NumberText;
